import * as React from 'react'
import './App.css'
import { FirestoreDocument } from 'react-firestore'
import Srnka from './Srnka'
import UserProvider from './UserProvider'
import Login from './Login'

class App extends React.Component {
	render() {
		return (
			<React.Fragment>
				<UserProvider>
					{user =>
						user ? (
							<FirestoreDocument
								path={`srnky/${user.email}`}
								render={({ isLoading, data }) =>
									isLoading ? null : <Srnka data={data} />
								}
							/>
						) : (
							<Login />
						)
					}
				</UserProvider>
				{/* <FirebaseContext.Consumer>
					{value =>
						value &&
						value.auth().currentUser && (

						)
					}
				</FirebaseContext.Consumer> */}
			</React.Fragment>
		)
	}
}
export default App



// WEBPACK FOOTER //
// ./src/App.js